import { useFrame, useThree } from '@react-three/fiber';
import { useRef } from 'react';
import { ECS } from '../state';
import { players } from '../queries';
import { beerConfig } from '@/config/games/beer';

const velocityEntities = ECS.world.with('velocity');
const movingEntities = ECS.world.with('position', 'velocity');
const followEntities = ECS.world.with('followPlayer', 'position');
const isJumpingEntities = ECS.world.with('isJumping');

export const SystemPhysics = () => {
  useFrameFixed(
    (fixedDelta) => {
      // Apply gravity to entities with velocity
      for (const entity of velocityEntities) {
        entity.velocity.y += beerConfig.player.gravity * fixedDelta;
        if (entity.position.y < 0) {
          entity.velocity.y = 0;
        }
      }

      // Update positions based on velocity
      for (const entity of movingEntities) {
        if (entity.stop) return;

        entity.position.x += entity.velocity.x * fixedDelta;
        entity.position.y += entity.velocity.y * fixedDelta;
      }
    },
    { fps: 120, max: 1 / 30 }
  );

  useFrame(() => {
    // FOLLOW
    const player = players.entities[0];

    for (const entity of followEntities) {
      const offset = entity.followOffset || { x: 0, y: 0, z: 0 };
      entity.position.x = player.position.x + offset.x;
      // entity.position.y = player.position.y + offset.y;
      entity.position.y = offset.y;
      entity.position.z = offset.z;
    }

    // Ground collision
    for (const entity of movingEntities) {
      if (entity.position.y < 0) {
        entity.position.y = 0;
      }
    }

    // Remove jumping state when entity hits ground
    for (const entity of isJumpingEntities) {
      if (entity.position.y <= 0) {
        console.log('SystemPhysics.remove jumping');
        ECS.world.removeComponent(entity, 'isJumping');
      }
    }
  });

  return null;
};
